<section
  class="user-profile-lessons-subpage profile-section"
  [class.mobile]="deviceService.isMobile()"
  [class.tablet]="deviceService.isTablet()"
  rel="lessons">
  <app-title [title]="'user-profile.tab-lessons'"></app-title>

  <div class="lessons-block" *ngIf="teachingSubjectsList?.length">
    <app-lesson
      *ngFor="let item of lessons.items"
      [content]="item"
      [view]="deviceService.isMobile() ? 'horizontal-square' : 'vertical-square'"
      (openInModal)="onOpenCard($event)"></app-lesson>
    <span *ngIf="!view" inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>
  </div>

  <ng-template [ngIf]="!isContent">
    <app-empty *ngIf="isMe" [empty]="emptyLessonObj"></app-empty>
  </ng-template>
</section>
